import type { Time } from "@core/shared/types";
import {
  formatLocalizedDateTime,
  formatLocalizedRelativeTime,
} from "./locale-formatters";

function timestampOf(time?: Time | number | null) {
  return typeof time === "number" ? time : time?.timestamp;
}

export function formatRelativeTime(time?: Time | number | null) {
  const timestamp = timestampOf(time);

  if (!timestamp) {
    return "";
  }

  const differenceInSeconds = Math.round((timestamp - Date.now()) / 1_000);
  const absoluteDifference = Math.abs(differenceInSeconds);
  let value = differenceInSeconds;
  let unit: Intl.RelativeTimeFormatUnit = "second";

  if (absoluteDifference >= 31_536_000) {
    value = Math.round(differenceInSeconds / 31_536_000);
    unit = "year";
  } else if (absoluteDifference >= 2_592_000) {
    value = Math.round(differenceInSeconds / 2_592_000);
    unit = "month";
  } else if (absoluteDifference >= 86_400) {
    value = Math.round(differenceInSeconds / 86_400);
    unit = "day";
  } else if (absoluteDifference >= 3_600) {
    value = Math.round(differenceInSeconds / 3_600);
    unit = "hour";
  } else if (absoluteDifference >= 60) {
    value = Math.round(differenceInSeconds / 60);
    unit = "minute";
  }

  return formatLocalizedRelativeTime(value, unit);
}

export function formatLocalizedDate(
  time?: Time | number | null,
  options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "long",
    year: "numeric",
  },
) {
  const timestamp = timestampOf(time);

  if (!timestamp) return "";

  return formatLocalizedDateTime(timestamp, options);
}
